<router-outlet></router-outlet>

<div [ngClass]="{'loader': loading}"></div>